import React from 'react';
import PropTypes from 'prop-types';

import { H1 } from 'components/core/Typography';
import { Section, Container } from 'components/core/Page';

import { ReviewBar } from 'components/molecules/ReviewBar/ReviewBar';

import { FacilityAddress } from 'components/facility/FacilityAddress';
import { Link } from 'components/core/Link';
import { formatCountCompact } from 'utils/formatting';
import isBrowser from 'utils/isBrowser';

import './FacilityDetails.scss';

export function FacilityDetails(props) {
	const reviewUrl = props.facilityUrl
		? `${props.facilityUrl}#reviews`
		: '#reviews';

	const handleReviewBarClick = (event) => {
		event.preventDefault();

		if (isBrowser() && globalThis.history?.replaceState) {
			const targetBaseUrl =
				props.facilityUrl || globalThis.location.pathname;
			globalThis.history.replaceState({}, '', `${targetBaseUrl}#reviews`);
		}

		props.scrollToReviews();
	};

	const hasVerifiedReviews = !!props.facility.reviews?.number;
	const hasGoogleReviews =
		props.isGoogleReviewEnabled &&
		Array.isArray(props.googleReviews?.reviews) &&
		props.googleReviews.reviews.length > 0;

	return (
		<Container className="facility-details">
			<Section className="facility-details__section">
				<div className="facility-details__header">
					<H1 className="facility-details__facility-name">
						{props.facility.name}
					</H1>
					<div className="facility-details__facility-address desktop">
						<FacilityAddress
							address={props.facility.location}
							className="facility-details__address"
							showSchema={props.showSchema}
						/>

						{!!props.phone && (
							<>
								<div className="gray-dot" />
								<Link
									href={`tel:${props.phone.number}`}
									className="facility-details__ph-number"
								>
									{props.phone.formattedNumber}
								</Link>
							</>
						)}
						{hasVerifiedReviews && (
							<>
								<div className="gray-dot" />
								<Link
									to={reviewUrl}
									className="facility-details__review-bar"
									onClick={handleReviewBarClick}
								>
									<ReviewBar
										average={props.facility.reviews.average}
										number={props.facility.reviews.number}
									/>
								</Link>
							</>
						)}
						{hasGoogleReviews && (
							<>
								<div className="gray-dot" />
								<Link
									to={reviewUrl}
									className="facility-details__review-bar"
									onClick={handleReviewBarClick}
								>
									<ReviewBar
										average={props.googleReviews.rating}
										number={formatCountCompact(
											props.googleReviews
												.user_ratings_total,
										)}
										icon="google"
									/>
								</Link>
							</>
						)}
					</div>
				</div>
				<div className="facility-details__facility-address mobile">
					<FacilityAddress
						address={props.facility.location}
						className="facility-details__address"
						showSchema={props.showSchema}
					/>
					{!!props.phone && (
						<>
							<div className="gray-dot" />
							<Link
								href={`tel:${props.phone.number}`}
								className="facility-details__ph-number"
							>
								{props.phone.formattedNumber}
							</Link>
						</>
					)}
					{hasVerifiedReviews && (
						<>
							<div className="gray-dot" />
							<Link
								to={reviewUrl}
								className="facility-details__review-bar"
								onClick={handleReviewBarClick}
							>
								<ReviewBar
									average={props.facility.reviews.average}
									number={props.facility.reviews.number}
								/>
							</Link>
						</>
					)}
					{hasGoogleReviews && (
						<>
							<div className="gray-dot" />
							<Link
								to={reviewUrl}
								className="facility-details__review-bar"
								onClick={handleReviewBarClick}
							>
								<ReviewBar
									average={props.googleReviews.rating}
									number={formatCountCompact(
										props.googleReviews.user_ratings_total,
									)}
									icon="google"
								/>
							</Link>
						</>
					)}
				</div>
			</Section>
		</Container>
	);
}

FacilityDetails.propTypes = {
	facility: PropTypes.object.isRequired,
	phone: PropTypes.shape({
		number: PropTypes.string,
		formattedNumber: PropTypes.string,
	}),
	googleReviews: PropTypes.object,
	isGoogleReviewEnabled: PropTypes.bool,
	facilityUrl: PropTypes.string,
	scrollToReviews: PropTypes.func.isRequired,
	showSchema: PropTypes.bool,
};
